<template>
    <input name="" id="all_traffic" value="true" type="checkbox" v-model="transportAllChecked" v-on:change='$emit("transportAllChecked", transportAllChecked)'>
    <label class="all" for="all_traffic">すべて選択</label>
</template>

<script>
    import { ref } from 'vue'
    export default ({
        props: {
            condition : {type: Object, require: true},
        },
        setup (props) {
            const transportAllChecked = ref(props.condition.transportationAllCheck)

            return {
                transportAllChecked
            }
        },
        emits: ['transportAllChecked']
    })
</script>